import React from "react";
import { Box, Typography, useTheme } from "@mui/material";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import CancelIcon from "@mui/icons-material/Cancel";
import { PASSWORD_REQUIREMENTS } from "../utils/passwordPolicy";

interface PasswordRequirementsChecklistProps {
  password: string;
}

/** Elenco live dei requisiti password: icona verde/rossa, aggiornato a ogni carattere digitato. */
export const PasswordRequirementsChecklist: React.FC<PasswordRequirementsChecklistProps> = ({
  password,
}) => {
  const theme = useTheme();

  return (
    <Box
      component="ul"
      aria-label="Requisiti password"
      sx={{ listStyle: "none", m: 0, p: 0, display: "flex", flexDirection: "column", gap: 0.5 }}
    >
      {PASSWORD_REQUIREMENTS.map((req) => {
        const ok = req.test(password);
        const color = ok ? theme.palette.success.main : theme.palette.error.main;
        return (
          <Box
            component="li"
            key={req.id}
            sx={{ display: "flex", alignItems: "center", gap: 1, color }}
          >
            {ok ? <CheckCircleIcon sx={{ fontSize: 16 }} /> : <CancelIcon sx={{ fontSize: 16 }} />}
            <Typography variant="caption" sx={{ color }}>
              {req.label}
            </Typography>
          </Box>
        );
      })}
    </Box>
  );
};

export default PasswordRequirementsChecklist;
